// extracted by mini-css-extract-plugin
export default {"container":"styles_container__d986j","content":"styles_content__Ls7av","logo":"styles_logo__uO33l","animatedButton":"styles_animatedButton__-cs2m","fadeIn":"styles_fadeIn__ZThGh"};